var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insurance-target-card"},[_c('span',{staticClass:"insurance-target-card__icon"},[_c('SvgIcon',{staticClass:"insurance-target-card__icon-pic",attrs:{"name":_vm.iconName,"size":"medium"}})],1),_c('p',{staticClass:"insurance-target-card__text",domProps:{"innerHTML":_vm._s(_vm.textHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }